import axios from 'axios'

export default {
    getPatientData(key) {
        return axios.get(`ehr/getPatientData?key=${key}`)
    },
}
